



































































import CommonBase from "../../CommonBase";
import {Component} from "vue-property-decorator";
import rd from "@/modules/vRoutedefs";
import ContactLink from "@/components/shared/ContactLink.vue";

interface Docroute {
  path: string;
  text: string;
}

@Component({
  components: {
    "at-contact": ContactLink,
  }
})
export default class TerminalIndexDoc extends CommonBase {
  readonly shopTo = rd.shop.path;
  readonly cardreadersTo = rd.terminals.path

  readonly subroutes: Docroute[] = [
    {path: rd.docs.terminal.reactivation.path, text: rd.docs.terminal.reactivation.title + ' av kortleser'},
    {path: rd.docs.terminal.networksetup.path, text: rd.docs.terminal.networksetup.title },
    {path: rd.docs.terminal.nocardread.path, text: rd.docs.terminal.nocardread.title },
  ];
}
